module.exports = __webpack_public_path__ + "static/media/icon-graphic-calendar.617a8f0a.svg";